import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors/base'

import Drawer from '@groovehq/internal-design-system/lib/components/Drawer/UnmanagedDrawer'

export function AdminAccessDrawer({
  open,
  onClose,
  title,
  isLoading,
  hasError,
  footer,
  container,
  isNoResultFound,
  children,
  ...rest
}) {
  const isCurrentUserManager = useSelector(selectCurrentUserIsAdminOrOwner)
  useEffect(
    () => {
      if (!isCurrentUserManager) onClose()
    },
    [onClose, isCurrentUserManager]
  )

  return (
    <Drawer
      {...rest}
      open={open}
      onClose={onClose}
      title={title}
      isLoading={isLoading}
      isError={hasError}
      footer={footer}
      container={container}
      isNoResultFound={isNoResultFound}
    >
      {children}
    </Drawer>
  )
}
